
// This file contains the original implementation of the toast functionality
import { useState, useEffect, useRef } from "react";
import { useToast as useToastShadcn, toast as toastShadcn } from "@/components/ui/toast";

// Export the hook directly
export const useToast = useToastShadcn;

// Export the toast function directly
export const toast = toastShadcn;
